const COMERCIAL_FIELDS = [
    'id',
    'SocioId',
    'firstName',
    'lastName',
    'clinica',
    'telefone_1',
    'telefone_2',
    'telefone_wp',
    'rqe',
    'zip',
    'street',
    'number',
    'complement',
    'neighborhood',
    'city',
    'state',
    'country',
    'check_divulgation',
    'especialista',
    'termosCondic',
    'check_adm',
    'status',
    'latitude',
    'longitude',
];

function splitName(nmSocio) {
    const parts = (nmSocio || '').trim().split(/\s+/).filter(Boolean);
    return {
        firstName: parts[0] || '',
        lastName: parts.slice(1).join(' ') || '',
    };
}

export function buildAdminComercialPayload(dadoComercial) {
    const payload = COMERCIAL_FIELDS.reduce((acc, field) => {
        if (dadoComercial[field] !== undefined && dadoComercial[field] !== null) {
            acc[field] = dadoComercial[field];
        }
        return acc;
    }, {});

    if ((!payload.firstName || !payload.lastName) && dadoComercial.Socio?.NM_SOCIO) {
        const { firstName, lastName } = splitName(dadoComercial.Socio.NM_SOCIO);
        payload.firstName = payload.firstName || firstName;
        payload.lastName = payload.lastName || lastName;
    }

    payload.SocioId = payload.SocioId || dadoComercial.Socio?.ID_SOCIO;
    payload.id = payload.id || dadoComercial.id;
    payload.check_adm = payload.check_adm || dadoComercial.check_adm || 'pendente';
    payload.status = payload.status || dadoComercial.status || 'ativo';
    payload.country = payload.country || 'Brasil';

    if (typeof payload.rqe !== 'string') {
        delete payload.rqe;
    }

    if (dadoComercial.Socio) {
        payload.Socio = {
            NM_SOCIO: dadoComercial.Socio.NM_SOCIO,
            CPF: dadoComercial.Socio.CPF,
            RG: dadoComercial.Socio.RG,
            CRM: dadoComercial.Socio.CRM,
            E_MAIL: dadoComercial.Socio.E_MAIL,
            DT_NASCTO: dadoComercial.Socio.DT_NASCTO,
            SEXO: dadoComercial.Socio.SEXO,
        };
    }

    return payload;
}

export function validateComercialData(objAddress, { hasPendingRqeFile = false } = {}) {
    if (!objAddress) {
        return { valid: false, message: 'Nenhum dado comercial selecionado.' };
    }

    if (!objAddress.firstName?.trim()) {
        return { valid: false, message: 'Por favor, informe o nome comercial.' };
    }

    if (!objAddress.lastName?.trim()) {
        return { valid: false, message: 'Por favor, informe o sobrenome comercial.' };
    }

    if (!objAddress.check_divulgation) {
        return { valid: true };
    }

    const hasRqe = hasPendingRqeFile || (typeof objAddress.rqe === 'string' && objAddress.rqe);

    if (objAddress.especialista && !hasRqe) {
        return { valid: false, message: 'Por favor, informe ou anexe o RQE.' };
    }

    if (!objAddress.clinica) {
        return { valid: false, message: 'Por favor, informe o nome da clínica.' };
    }

    if (!objAddress.telefone_1) {
        return { valid: false, message: 'Por favor, informe o telefone principal.' };
    }

    if (objAddress.telefone_1.length < 14) {
        return { valid: false, message: 'O telefone principal deve ter pelo menos 14 caracteres. Verifique o DDD.' };
    }

    if (!objAddress.zip) {
        return { valid: false, message: 'Por favor, informe o CEP.' };
    }

    if (!/^\d{5}-\d{3}$/.test(objAddress.zip)) {
        return { valid: false, message: 'CEP inválido.' };
    }

    if (!objAddress.street) {
        return { valid: false, message: 'Por favor, informe a rua.' };
    }

    if (!objAddress.number) {
        return { valid: false, message: 'Por favor, informe o número.' };
    }

    if (!/^\d+$/.test(String(objAddress.number))) {
        return { valid: false, message: 'Número inválido.' };
    }

    if (!objAddress.neighborhood) {
        return { valid: false, message: 'Por favor, informe o bairro.' };
    }

    if (!objAddress.city) {
        return { valid: false, message: 'Por favor, informe a cidade.' };
    }

    if (!objAddress.state) {
        return { valid: false, message: 'Por favor, informe o estado.' };
    }

    if (!/^[A-Z]{2}$/.test(objAddress.state)) {
        return { valid: false, message: 'Estado inválido.' };
    }

    if (objAddress.telefone_2 && objAddress.telefone_2.length < 14) {
        return { valid: false, message: 'O telefone secundário deve ter pelo menos 14 caracteres. Verifique o DDD.' };
    }

    if (objAddress.telefone_wp && objAddress.telefone_wp.length < 14) {
        return { valid: false, message: 'O WhatsApp deve ter pelo menos 14 caracteres. Verifique o DDD.' };
    }

    if (!objAddress.country) {
        return { valid: false, message: 'Por favor, informe o país.' };
    }

    return { valid: true };
}
